import { DeleteModal } from '@presentation/components/templates'

type Props = {
  id: string
  onDelete: () => void
}

const DeleteSetorModal: React.FC<Props> = ({ id, onDelete }) => {
  const modalConfigs = {
    id,
    path: '/setores',
    nameForTitle: 'Setor',
    onDelete
  }

  return <DeleteModal {...modalConfigs} />
}

export default DeleteSetorModal
